import { render, staticRenderFns } from "./RoleChat.vue?vue&type=template&id=09d7c234&scoped=true"
import script from "./RoleChat.vue?vue&type=script&lang=js"
export * from "./RoleChat.vue?vue&type=script&lang=js"
import style0 from "./RoleChat.vue?vue&type=style&index=0&id=09d7c234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d7c234",
  null
  
)

export default component.exports